import { Flex, Stack } from '@mantine/core';
import { MessageBoxImagePreview } from './MessageBoxImagePreview';
import { MessageBoxPDFList } from './MessageBoxPDFList';

export type FileInputListDisplayProps = {
  files: File[];
  removeFile: (indexToRemove: number) => void;
  handlePdfPreview: (file: File) => void;
  formatFileSize: (size: number) => string;
};

export function FileInputListDisplay(props: FileInputListDisplayProps) {
  const { files, removeFile, handlePdfPreview, formatFileSize } = props;
  return (
    <>
      {files.length > 0 && (
        <Stack gap="sm" mt="md">
          {/* Images section */}
          {files.some((file) => file.type.startsWith('image/')) && (
            <Flex gap="xs" wrap="wrap" align="flex-start">
              {files
                .map((file, index) => ({ file, index }))
                .filter(({ file }) => file.type.startsWith('image/'))
                .map(({ file, index }) => (
                  <MessageBoxImagePreview key={index} file={file} index={index} onRemove={removeFile} />
                ))}
            </Flex>
          )}

          {/* Non-image files section */}
          {files.some((file) => !file.type.startsWith('image/')) && (
            <Stack gap="xs">
              {files
                .map((file, index) => ({ file, index }))
                .filter(({ file }) => file.type.startsWith('application/pdf'))
                .map(({ file, index }) => (
                  <MessageBoxPDFList
                    key={index}
                    file={file}
                    index={index}
                    onRemove={removeFile}
                    onPreview={handlePdfPreview}
                    formatFileSize={formatFileSize}
                  />
                ))}
            </Stack>
          )}
        </Stack>
      )}
    </>
  );
}
